<template src="./templates/Locations.html" />

<script setup>

import VueMultiselect from 'vue-multiselect';
import { useLocationsStore } from '@timezoneone/dottie-client-jam';

const locationsStore = useLocationsStore();

const onSelect = (option) => {

    // eslint-disable-next-line
    option.checked = true;

};

const onRemove = (option) => {

    // eslint-disable-next-line
    option.checked = false;

};

</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>

<!--todo - add custom styles for multiselect-->
<style lang="scss" >

</style>
